module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/money-9ea4723cc1eb9d308b63524c92a724aa.svg";